import React from 'react';
import { classes } from './Header.st.css';
import { TagName } from '../../../../utils/tagName.const';
import { Header as FormHeader } from '@wix/ambassador-services-catalog-server/http';
import { HeaderDataHooks } from './dataHooks';
import Text, { TextType } from '../../Text/Text';
import { SectionTitle } from '../SectionTitle/SectionTitle';

export const Header: React.FC<FormHeader> = ({
  title,
  description,
  isDescriptionHidden,
}) => {
  const showDescription = !isDescriptionHidden;

  return (
    <div className={classes.root}>
      <SectionTitle label={title!} tagName={TagName.MainHeading} />
      {showDescription ? (
        <Text
          type={TextType.Primary}
          className={classes.description}
          data-hook={HeaderDataHooks.DESCRIPTION}
          tagName={TagName.Paragraph}
        >
          {description}
        </Text>
      ) : null}
    </div>
  );
};
export default Header;
